import {Route, Routes} from "react-router-dom";
import Home from "./pages/Home/Home";
import Layout from './components/layout';
// import About from "./pages/About/About";
import Contact from './pages/Contact/Contact';
import Demo from './pages/Demo/Demo';
import Products from './pages/Products/Products';
import Blogs from './pages/Blogs/Blogs';
import NotFound from "./pages/NotFound/NotFound";
 
function App() {
  return (
    <Routes>
      <Route path="/"  element={<Layout/>}>
        <Route path="" element={<Home/>} />
        {/* <Route path="about" element={<About/>} /> */}
        <Route path="blogs" element={<Blogs/>} />
        <Route path="products" element={<Products/>} />
        <Route path="contact" element={<Contact/>} />
        <Route path="demo" element={<Demo/>} />
      </Route>
      <Route path = "*" element = {<NotFound/>} />
    </Routes>
  );
}

export default App;
